import React from 'react'

export default class WxLoginCode extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            //  一个appid对应一个回调地址
            APPID: window.data_config.weixin_appid,
            // 扫码成功后要跳转的页面
            REDIRECT_URI: `${window.sitesetting.HOST}${window.root_directroy ? window.root_directroy + '/' : ''}index.php?weixin/wxcallback`
        }
    }

    componentDidMount() {
        new window.WxLogin({
            self_redirect: false,
            id: "wechat-code",
            appid: this.state.APPID,
            scope: "snsapi_login",
            redirect_uri: this.state.REDIRECT_URI,
            state: this.state.APPID,
            href: `${window.sitesetting.HOST}${window.root_directroy ? window.root_directroy + '/' : ''}static/style/css/wxqrcode.css?v=1.001`
        });
    }

    render() {
        return <div id='wechat-code' style={{'display':'flex','justify-content':'center',height:'279px','overflow':'hidden'}} >

        </div>
    }
}